import LocalPhoneOutlinedIcon from 'components/material-symbol/icons/LocalPhone'
import EmailOutlinedIcon from 'components/material-symbol/icons/Email'
import PersonOutlineIcon from 'components/material-symbol/icons/PersonOutline'
import InfoOutlinedIcon from 'components/material-symbol/icons/Info'
import TipWell from 'components/tip-well'
import { formatNameForDisplay } from 'lib/text-display'
import { useSnackbar } from 'notistack'
import { useSnackbarSuccess } from 'lib/snackbar'
import {
  DetailSection,
  ContactField,
} from 'pages/pga-coach/students/student-show-page/details-components/content-box'

export default function DisplayContact({
  contact = {
    firstName: '',
    lastName: '',
    phoneNumber: '',
    phone: '',
    email: '',
  },
}) {
  const { firstName, lastName, phoneNumber, phone, email } = contact
  const contactName = formatNameForDisplay(`${firstName} ${lastName}`)
  const resolvedPhone = phoneNumber || phone

  const { enqueueSnackbar } = useSnackbar()
  const snackbarSuccess = useSnackbarSuccess(enqueueSnackbar)

  const copyToClipboard = async (event, text) => {
    event.stopPropagation()
    navigator.clipboard.writeText(text)
    snackbarSuccess('Successfully copied to clipboard.')
  }

  return (
    <DetailSection title="Contact" compact stacked>
      <ContactField
        icon={PersonOutlineIcon}
        label="Name"
        value={firstName ? contactName : 'N/A'}
        testId="lead-contact-name"
      />
      <ContactField
        icon={LocalPhoneOutlinedIcon}
        label="Phone"
        value={resolvedPhone || 'N/A'}
        href={resolvedPhone ? `tel:${resolvedPhone}` : undefined}
        onCopy={
          resolvedPhone
            ? event => copyToClipboard(event, resolvedPhone)
            : undefined
        }
        testId="lead-contact-phone"
      />
      <ContactField
        icon={EmailOutlinedIcon}
        label="Email"
        value={email || 'N/A'}
        href={email ? `mailto:${email}` : undefined}
        onCopy={email ? event => copyToClipboard(event, email) : undefined}
        testId="lead-contact-email"
      />
      <TipWell
        icon={InfoOutlinedIcon}
        caption="Consider keeping all of your conversations within the PGA Coach platform to protect your personal contact information."
      />
    </DetailSection>
  )
}
